import PropTypes from 'prop-types';
import {getMultiNamesObject} from "../utilities";

export const TranslatesInterface = getMultiNamesObject(PropTypes.string);
